export const styleReactSelect = {
    control: (styles) => ({ ...styles, backgroundColor: '#F5F5F5' })
}

export const styleReactSelectRequired = {
  control: (styles) => ({ ...styles, backgroundColor: '#F5F5F5', borderColor:'#E4555A' })
}